import { ClientSessionStageTypes } from "./IClientSessionDTO";
import { IDocumentTypeDTO } from "./IDocumentTypeDTO";

export enum ClientStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  PENDING = "p",
  DELETED = "x",
}

export type ClientStatusTypes = `${ClientStatusEnum}`;
export type ClientTypeTypes = "g" | "c";

export interface IClientDTO {
  id: number;
  type: ClientTypeTypes;
  cellPhone?: string;
  email?: string;
  atSign?: string;
  name?: string;
  documentType: string | null;
  document: string;
  language: string;
  status: ClientStatusTypes;
  documentTypeData: IDocumentTypeDTO;
  photos: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface IClientAuthDTO {
  client: IClientDTO;
  stage: ClientSessionStageTypes;
}

export interface IClientPublicDTO {
  id: number;
  atSign: string;
  name: string;
  language: string;
  status: ClientStatusTypes;
  avatar?: string;
  referralLink?: string;
  createdAt: string;
  updatedAt: string;
}

export interface IClientStatusDTO {
  status: string;
  text: string;
  title: string;
  color: string;
}
